import { IconProps } from "../../utils/global-types/global-types";

const PinIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_3995_33713)">
        <path
          fill="currentColor"
          d="M14.702 8.39a1.244 1.244 0 0 1-1.654.319c-.146-.097-.146-.094-.306.069-.788.798-1.004 1.012-1.66 1.662l-.295.294c-.046.043-.054.041-.019.09.837 1.26.305 2.67-.474 3.571-.396.426-.807.433-1.223.05-.723-.726-1.256-1.243-2.042-2.05-.075-.066-.042-.078-.143 0q-.927.758-1.858 1.51l-1.124.909a.68.68 0 0 1-.427.188.47.47 0 0 1-.332-.148c-.3-.293-.078-.6.019-.731.772-1.057 1.524-2.11 2.312-3.166.057-.08.048-.06-.021-.133A362 362 0 0 1 3.61 8.98c-.453-.448-.427-.902.056-1.321.905-.79 2.456-1.201 3.541-.41l.022.015c.935-.944 1.334-1.343 2.151-2.153a1.328 1.328 0 0 1 2.006-1.727A421 421 0 0 1 14.63 6.63a1.313 1.313 0 0 1 .071 1.76"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3995_33713">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PinIcon;
